// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1DMCT","labelText":"style_labelText__1QvWS","right":"style_right__1GLWD"};